React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_list_component')

LOADED = 0
LOADING_NEW = 1
LOADING_NEXT = 2
LOADING_ERROR = 3

module.exports = class ListComponent extends React.Component
  @LOADING_STATES: { LOADED, LOADING_NEW, LOADING_NEXT, LOADING_ERROR }

  render: t.renderable ->
    { itemInlineButtons, itemDependencies, itemEventHandlers, itemComponent, isPopOver, loadingState, items } = @props
    t.div
      class: t.classify('is-loading': loadingState == LOADING_NEW)
    , =>
      t.div '.spinner.loading.search-spinner',
        class: t.classify(hide: loadingState != LOADING_NEW)
      if loadingState == LOADING_ERROR
        t.div '.dashboard-list-item.dashboard-list-error', ->
          t.format 'loading-error'
      else if loadingState == LOADED && items.length == 0
        t.div '.dashboard-list-item.dashboard-list-none', ->
          t.format 'no-results'
      t.ul
        class: t.classify('pop-over-list': isPopOver)
      , =>
        items.forEach (item) ->
          t.li =>
            t.addElement React.createElement itemComponent, {
              item
              dependencies: itemDependencies
              eventHandlers: itemEventHandlers
              checkedStatus: itemInlineButtons
            }
      if loadingState == LOADING_NEXT
        t.div '.spinner.loading.pagination-spinner'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/list-component.coffee